import React from 'react'

import NoSearchResults from './NoSearchResults'
import SearchOption from './SearchOption'
import SearchOptions from './SearchOptions'
import SearchSelect from './SearchSelect'
import SearchSelectedTags from './SearchSelectedTags'

const ContactMethodSelect = ({
  onSelect = () => {},
  onRemove = () => {},
  onClear = () => {},
  initialSelected = [],
  dropdownHeight,
  options = [],
  inputProps = {},
  placeholder = 'Select or type contact methods',
}) => {
  const filterOptions = (searchTerm, selectedOptions) => {
    const selectedValues = selectedOptions.map(opt => opt.value)
    let filtered = options.filter(o => !selectedValues.includes(o))

    if (searchTerm) {
      const lowerSearch = searchTerm.toLowerCase()
      filtered = filtered.filter(o => o.toLowerCase().includes(lowerSearch))
    }

    return filtered
  }

  const renderOptions = ({ searchTerm, selectedOptions }) => {
    const filtered = filterOptions(searchTerm, selectedOptions)

    if (filtered.length === 0) {
      return <NoSearchResults>No contact methods found</NoSearchResults>
    }

    return filtered.map(option => (
      <SearchOption
        key={option}
        option={{ label: option, value: option }}
        onSelect={onSelect}
      >
        {option}
      </SearchOption>
    ))
  }

  return (
    <SearchSelect>
      <SearchOptions
        onClear={onClear}
        initialSelected={initialSelected.map(v => ({ label: v, value: v }))}
        dropdownHeight={dropdownHeight}
        inputProps={{ placeholder, ...inputProps }}
      >
        {renderOptions}
      </SearchOptions>
      <SearchSelectedTags onRemove={onRemove} />
    </SearchSelect>
  )
}

export default ContactMethodSelect
